import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../Auth/AuthProvider";
import jwt_decode from "jwt-decode";
import React from "react";

const Auth = ({ allowedRoles }) => {
  console.log("allowedRoles",allowedRoles)
  const { auth, setAuth, accessToken } = useContext(AuthContext);
  const location = useLocation();
  let permissionArray = [];
  if (accessToken) {
    const decodedToken = jwt_decode(accessToken);
    const permissions = decodedToken.permissions;
    
    permissions &&
      permissions.map((vl) => {
        permissionArray.push(vl.name);
      });
  }

  return <Outlet />// allowedRoles.find((role) => permissionArray.includes(role)) ? (
    
  // ) : (
  //   <Navigate to={"/no-access"} state={{ from: location }} replace />
  // );
};

export default Auth;
